import { getPlaceDetails } from './maps';

const CACHE_DURATION = 60 * 1000; // 1 minute
const FAVORITES_KEY = 'beezy-favorites';
const POPULARITY_CACHE_KEY = 'popularity-cache';
const LAST_UPDATE_KEY = 'last_favorites_update';

export const getFavorites = () => {
  return JSON.parse(localStorage.getItem('beezy-favorites') || '[]');
};

export const addFavorite = (place) => {
  const favorites = JSON.parse(localStorage.getItem('beezy-favorites') || '[]');
  const updatedFavorites = [...favorites, place];
  localStorage.setItem('beezy-favorites', JSON.stringify(updatedFavorites));
};

export const removeFavorite = (placeId) => {
  const favorites = JSON.parse(localStorage.getItem('beezy-favorites') || '[]');
  const updatedFavorites = favorites.filter((place) => place.place_id !== placeId);
  localStorage.setItem('beezy-favorites', JSON.stringify(updatedFavorites));
};

export const isInFavorites = (placeId) => {
  try {
    const favorites = getFavorites();
    return favorites.some((f) => f.place_id === placeId);
  } catch (error) {
    console.error('Error checking favorites:', error);
    return false;
  }
};

export const getCachedPopularity = (placeName) => {
  try {
    const cache = JSON.parse(localStorage.getItem(POPULARITY_CACHE_KEY) || '{}');
    const data = cache[placeName];
    if (data && Date.now() - data.timestamp < CACHE_DURATION) {
      return data.popularity;
    }
    return null;
  } catch (error) {
    console.error('Error getting cached popularity:', error);
    return null;
  }
};

export const cachePopularity = (placeName, popularity) => {
  try {
    const cache = JSON.parse(localStorage.getItem(POPULARITY_CACHE_KEY) || '{}');
    cache[placeName] = {
      popularity,
      timestamp: Date.now(),
    };
    localStorage.setItem(POPULARITY_CACHE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.error('Error caching popularity:', error);
  }
};

export const refreshFavoritesFromAPI = async () => {
  const favorites = getFavorites();
  try {
    const updatedFavorites = await Promise.all(
      favorites.map(async (place) => {
        try {
          if (place.place_id) {
            const updatedPlace = await getPlaceDetails(place.place_id);
            return {
              ...place,
              current_popularity: updatedPlace.current_popularity,
              business_status: updatedPlace.business_status,
              is_open: updatedPlace.is_open,
            };
          }
          return place;
        } catch (error) {
          console.error(`Error updating ${place.name}:`, error);
          return place;
        }
      })
    );
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(updatedFavorites));
    return updatedFavorites;
  } catch (error) {
    console.error('Error refreshing favorites:', error);
    return favorites;
  }
};

export const getFavoritesWithRefresh = async (onUpdate) => {
  // 1. Retourner immédiatement les données en cache
  const cachedFavorites = getFavorites();

  // 2. Vérifier si on doit rafraîchir
  const lastUpdate = localStorage.getItem(LAST_UPDATE_KEY);
  const shouldRefresh = !lastUpdate || Date.now() - parseInt(lastUpdate) > CACHE_DURATION;

  if (shouldRefresh) {
    // 3. Refresh en background
    refreshFavoritesFromAPI().then((updatedFavorites) => {
      localStorage.setItem(LAST_UPDATE_KEY, Date.now().toString());
      if (onUpdate) onUpdate(updatedFavorites);
    });
  }

  return cachedFavorites;
};
